import axios from "axios";
import dayjs from "dayjs";
import { store } from "../../App";
import { LOGOUT } from "../../store/actions/authenticationAction";
import { createCredential } from "../../store/actions/credentialsAction";
import { createDoors } from "../../store/actions/doorsAction";
import { handleLoading } from "../../store/actions/loadingAction";
import { editCurrentUser, updateUser } from "../../store/actions/usersAction";
import separateFaceIdType from "../../utils/separateFaceIdType";
import { onSocketAction } from "../../store/actions/onSocketAction";

const smalltalk = require("smalltalk");

const FACE_V2_PASS = 12345678;
const type = separateFaceIdType();

export const BACKEND_API = "http://localhost:5001";
const BIOSTAR_PASS = [
  { centerId: "66bdca9b7add38fef2918d63", pass: "1a2s3d4f" },
  { centerId: "62d3de0de4b5f62ba339b22d", pass: "1a2s3d4f" },
  { centerId: "62d3de11e4b5f62ba339b22f", pass: "Admin123" },
];
export const bioLogin = async () => {
  try {
    const centerId = JSON.parse(localStorage.getItem("centerId")).centerId;
    const faceType = await separateFaceIdType();
    if (faceType === 0 || faceType === 1) {
      const token = await (
        await fetch(`${BACKEND_API}/auth/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            password: BIOSTAR_PASS.find((a) => a.centerId === centerId).pass,
          }),
        })
      )
        .json()
        .then((a) => a.token)
        .catch((e) => {
          console.log(e);
        });
      if (token) localStorage.setItem("bs-session-id", token);
    }
  } catch (e) {
    console.log(e)
  }

};

export const bioLogout = async () => {
  const faceType = separateFaceIdType();
  if (faceType === 0 || faceType === 1)
    await fetch(BACKEND_API + "/auth/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        localStorage.removeItem("bs-session-id");
      })
      .catch((e) => {
        //  throw e
      });
};

export const bioCreateUser = async (user, isUpdate) => {
  try {
    await createPerson(user, isUpdate);
  } catch (e) {
    throw e
  }
};

const createPerson = async (user, isUpdate) => {
  try {
    //!create person or update
    await fetch("http://localhost:5001/users/register-user/2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user, isUpdate }),
    }).then(async a => {
      if (a.status !== 200) {
        throw a
      }
    }).catch((e) => {
      throw e;
    });
  } catch (e) {
    throw e
  }
};

const logoutSession = async () => {
  handleLoading();
  smalltalk.alert("", "session expired please login again");
  await bioLogout();
  LOGOUT();
};

export const bioOpenDoor = async (data) => {
  try {
    openDoorFace2(data);
  } catch (e) {
    throw e;
  }
};

export const openDoorFace2 = async (data) => {
  try {
    //!check if user exist or not in face v2
    await fetch(BACKEND_API + `/doors/open/2`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ door: data.door })
    });
    await createDoors(data);
  } catch (e) {
    alert(e);
    throw e;
  }
};
//*done
export const bioGetAccessLevels = async () => {
  try {

    return await fetch(BACKEND_API + "/utilities/access-levels/" + 2, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((a) => a.json())
      .then((a) => {
        console.log(a);
        return a;
      })
      .catch((e) => {
        throw e;
      });
  } catch (e) {
    throw e;
  }
};

export const bioGetUser = async (id) => {
  try {
    const token = localStorage.getItem("bs-session-id");
    const faceType = separateFaceIdType();
    return await fetch(
      BACKEND_API + `/users/get-user/${faceType === 2 ? 2 : 1}/${id}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
          "bs-session-id": token,
        },
        body: JSON.stringify({ token }),
      }
    )
      .then(async (res) => {
        if (res.status === 500 || res.status === 401) {
          return await logoutSession();
        }
        let dt = await res.json();
        // return dt.User;
        return dt

      })
      .catch((e) => {
        throw e;
      });
  } catch (e) {
    throw e;
  }
};

export const bioGetMainFaceStation = async () => {
  try {
    const token = localStorage.getItem("bs-session-id");

    return await fetch(`/api/devices`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "*/*",
        "bs-session-id": token,
      },
    })
      .then(async (res) => {
        let dt = await res.json();
        let data = dt.DeviceCollection.rows;
        return await data.find((a) => a.name === "0");
      })
      .catch((e) => {
        throw e;
      });
  } catch (e) {
    throw e;
  }
};

export const bioGetCredential = async (user, accessGroups, faceIp, isUpdatePath) => {
  try {

    return await getFaceTakeImg(user, faceIp, isUpdatePath);

  } catch (e) {
    throw e;
  }
};

const getFaceTakeImg = async (user, faceIp, isUpdatePath) => {

  await fetch("http://localhost:5001/faces/add-face/2", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user, faceIp, isUpdatePath }),
  });
};

export const bioUploadPicture = async (credentials, currentUser) => {
  try {
    const token = localStorage.getItem("bs-session-id");
    let body = {
      template_ex_picture:
        credentials.visualFaces[0].template_ex_normalized_image,
    };
    return await fetch(`/api/users/check/upload_picture`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "*/*",
        "bs-session-id": token,
      },
      body: JSON.stringify(body),
    })
      .then(async (res) => {
        let dt = await res.json();
        const image = dt.image;
        let newCredentials = { ...credentials };
        delete newCredentials.visualFaces[0].template_ex_normalized_image;
        newCredentials.visualFaces[0].template_ex_picture = image;
        await bioUpdateUser(currentUser.bioStarID, newCredentials);
        // await updateUser({ ...currentUser, credential: image }, false);
        await createCredential({ userId: currentUser._id, credential: image });
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  } catch (e) {
    throw e;
  }
};

const bioUpdateUser = async (id, credentials) => {
  try {
    const token = localStorage.getItem("bs-session-id");
    const body = { User: { credentials } };

    return await fetch(`/api/users/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "*/*",
        "bs-session-id": token,
      },
      body: JSON.stringify(body),
    })
      .then(async (res) => { })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  } catch (e) {
    throw e;
  }
};

export const bioGetUsers = async () => {
  try {
    const token = localStorage.getItem("bs-session-id");

    return await fetch(`/api/users`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "*/*",
        "bs-session-id": token,
      },
    })
      .then(async (res) => {
        let dt = await res.json();

        return dt.UserCollection;
      })
      .catch((e) => {
        throw e;
      });
  } catch (e) {
    throw e;
  }
};
export const onDeleteUser = async (data) => {
  try {
    return await fetch("http://localhost:5001/users/delete-user/2", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: data, }),
      }).then(async a => {
        if (a.status !== 200) {
          throw a
        }
      }).catch((e) => {
        throw e;
      });

  } catch (e) {
    throw e;
  }
};

export const executeSocketActions = async () => {
  try {
    const currentCenterId = JSON.parse(localStorage.getItem("centerId")).centerId;
    const res = await axios.get('/socket-actions?centerId=' + currentCenterId)

    await Promise.all(res.data.map(async (a) => {
      const d = { type: a.actionType, data: a.actionData, serverId: a.serverId }
      await onSocketAction(d);
      // delete action
      await axios.delete('/socket-actions/' + a._id)
    }
    ))
  } catch (e) {
    console.log(e)
  }
}